import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    currentUserHash: String
  }

  connect() {
    if (!this.currentUserHashValue) {
      return
    }

    this.handleMediavineIdentityReady = this.handleMediavineIdentityReady.bind(this)
    window.addEventListener('mediavineIdentityReady', this.handleMediavineIdentityReady)
  }

  disconnect() {
    window.removeEventListener('mediavineIdentityReady', this.handleMediavineIdentityReady)
  }

  handleMediavineIdentityReady() {
    if (window.$mediavine && window.$mediavine.web && window.$mediavine.web.identityOptIn) {
      console.log("Mediavine identity ready")
      window.$mediavine.web.identityOptIn({
        email: this.currentUserHashValue
      }, (error) => {
        if (error) {
          console.error(error)
        }
      })
    }
  }
}
